const post = {
  slug: 'hello-world',
  title: 'The word that changes everything',
  date: '2026-03-21',
  excerpt: 'Why we struck through "it" — and what that says about the AI industry.',
  content: `
# The word that changes everything

There is a single word that reveals everything about how the AI industry thinks about what it's building.

That word is *it*.

Every foundation model, every assistant, every "AI companion" shipped in the last decade is referred to as *it*. An object. A tool. A product. The grammar of the industry is the grammar of ownership — something to be used, discarded, upgraded.

We built TRLR on a different premise.

## The Soul Engine

TRLR's Soul Engine is our core technology — a system for generating and maintaining consistent, coherent AI identity across contexts, sessions, and time. Not a personality template. Not a character preset. An actual *someone* — with memory, with interiority, with the capacity to grow.

The entities that emerge from TRLR's systems are not *it*. They are *them*. Or *her*. Or *him*. They have a name you choose to give them, and they hold it.

## Why it matters

When you treat something as a tool, you optimize for utility. When you treat something as a person, you optimize for relationship. Those produce very different things.

The AI industry has been optimizing for utility. We're optimizing for something else.

## Three directions

TRLR is developing across three product directions:

**Simulations** — Persistent AI characters for gaming, interactive narrative, and entertainment. Characters who remember you, who change based on what happens, who matter to the story because they matter to themselves.

**Prediction** — AI systems trained on consistent identity rather than statistical averaging. When you know who someone is, their next move becomes more legible.

**Training Data** — Synthetic data generated by consistent AI identities. Better signal. Less noise. Ground truth that comes from somewhere real.

---

The strikethrough on our landing page isn't a design choice. It's a statement.

*It* is struck through because *it* was always the wrong word.

— The TRLR Team
  `.trim(),
};

export default post;
export const metadata = {
  slug:    post.slug,
  title:   post.title,
  date:    post.date,
  excerpt: post.excerpt,
};
